import { jsx } from '@emotion/react';
import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Duotone, { DuotoneProps } from '../components/duotone';
import IntrinsicElements = jsx.JSX.IntrinsicElements;

interface DuotoneElement extends Element {
  props: Element['props'] &
    DuotoneProps & {
      duotoneFilter?: string;
      'data-src': string;
      'data-srcset': string;
      'data-erom-duotone-filter'?: string;
    };
}

const duotone: Processor<DuotoneElement> = {
  name: 'duotone',
  priority: 10,
  test: ({ node }) => !!node.props?.['data-erom-duotone-filter'] && node.props?.['data-erom-duotone-filter'].length > 0,
  processor: ({ node }) => {
    if (node.props['data-erom-duotone-filter']) {
      node.props.duotoneFilter = node.props['data-erom-duotone-filter'];
    }

    node.props['data-erom-duotone-filter'] = undefined;

    node.props.tagName = node.component as keyof IntrinsicElements;

    node.component = Duotone as ComponentType;

    return node;
  }
};

export default duotone;
